import { Directive, ElementRef, HostListener, Input } from '@angular/core';

type WheelHorizontalScrollDirectiveConfig = {
  isDisabled?: boolean;
};

@Directive({
  selector: '[atxWheelHorizontalScroll]',
  standalone: true,
})
export class WheelHorizontalScrollDirective {
  @Input('atxWheelHorizontalScroll')
  public config: WheelHorizontalScrollDirectiveConfig = {};

  constructor(private host: ElementRef) {}

  @HostListener('wheel', ['$event'])
  public scroll(event: WheelEvent) {
    if (this.config.isDisabled) {
      return;
    }

    event.preventDefault();

    let scrollStep = event.deltaY;
    if (scrollStep === 0 && event.deltaX !== 0) {
      scrollStep = event.deltaX;
    }

    this.host.nativeElement.scrollBy({
      left: scrollStep,
    });
  }
}
